import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import PlaceholderImage from "./placeholderImage";

export const FormField = ({
	defaultVal = null,
	options = [],
	input,
	label,
	formGroupClass = "",
	checkboxGroupClass = "",
	responseError = null,
	min,
	max,
	step,
	type,
	viewValue = null,
	onSelect = null,
	disabled = false,
	propsDatePicker = { dateFormat: "yyyy-MM-dd" },
	meta: { touched, error, warning }
}) => {
	const props = type === "number" ? { min, max, step } : {};
	const [datepickerProps, setDatepickerProps] = useState({
		selected: new Date(input && input.value ? input.value : null),
		...propsDatePicker
	});

	useEffect(() => {
		type === "datepicker" &&
			setDatepickerProps({ ...datepickerProps, selected: new Date(input && input.value ? input.value : null) });
	}, [input, datepickerProps, type]);

	const onDatePickerChange = (event) => {
		if (event) {
			input.onChange((input.value = event));
		}
	};

	const setViewValue = (values, option) => {
		const typeofViewValue = values && typeof values;
		let newValue = "";
		if (typeofViewValue === "object") {
			values.map((item) => {
				return (newValue = newValue + option[item] + " ");
			});
		} else {
			return option[values];
		}
		return newValue;
	};
	return (
		<div className={`form-group ${formGroupClass} ${touched && (error ? "error" : warning ? "warning" : "")}`}>
			{type !== "checkbox" && type !== "radio" && type !== "thumbnail" && type !== "nutrition_label" ? (
				<label htmlFor={input.name} className="form-label m-0">{label}</label>
			) : null}

			{type === "select" ? (
				<select {...input} id={input.name} className="form-control" onChange={(event) => {
					if (onSelect) {
						onSelect(event);
					}
					return input.onChange(event);
				}}>
					<option value={defaultVal ? defaultVal : ""}>Select {label}</option>
					{options.length &&
						options.map((option, index) => (
							<option key={index} value={option.id}>
								{viewValue ? setViewValue(viewValue, option) : option.name}
							</option>
						))}
				</select>
			) : type === "textarea" ? (
				<textarea {...input} id={input.name} className="form-control" placeholder={label} />
			) : type === "checkbox" || type === "radio" ? (
				<label className="form-label m-0">
					<input {...input} className="form-control" type={type} />
					<span className="form-label-span">{label}</span>
				</label>
			) : type === "checkboxGroup" ? (
				<div className="row">
					{options &&
						options.map(({ label, name }, index) => {
							return (
								<div key={index} className={`form-group ${checkboxGroupClass}`}>
									<label className="form-label m-0">
										<input
											className="form-control"
											type="checkbox"
											name={`${input.name}["${name}"]`}
											value={name}
											checked={input.value.indexOf(name) !== -1}
											onChange={(event) => {
												const newValue = [...input.value];
												if (event.target.checked) {
													newValue.push(name);
												} else {
													newValue.splice(newValue.indexOf(name), 1);
												}

												return input.onChange(newValue);
											}}
										/>
										<span className="form-label-span">{label}</span>
									</label>
								</div>
							);
						})}
				</div>
			) : type === "thumbnail" && options.id && options.image ? (
				<label className={`form-label m-0 ${disabled ? "disabled" : ""}`}>
					<PlaceholderImage
						className="image-thumbnail"
						src={options.image}
						width="120"
						height="70"
						bg="rgba(0,0,0,0.1)"
						color="rgba(0,0,0,0.3)"
						objectFit="cover"
					/>
					<input
						{...input}
						className="form-control"
						type="checkbox"
						onChange={(event) => {
							if (onSelect) {
								onSelect(event.target.checked, options);
							}
							return null;
						}}
					/>
					<span className="form-label-span" />
				</label>
			) : type === "datepicker" ? (
				<DatePicker {...datepickerProps} onChange={onDatePickerChange} />
			) : type === "label" ? (
				<label htmlFor={input.name} className="form-label m-0 foodList_View_Data">{input.value ? input.value : "-"}</label>
			) : type === "nutrition_label" ? (
				<>
					<label htmlFor={input.name} className="form-label col m-0">{label}</label>
					<label htmlFor={input.name} className="form-label col m-0 foodList_View_Data">{input.value ? input.value : "-"}</label>
				</>
			) : type === "select_to_label" ? (
				options.map((option, index) => (
					option.id.toString() === input.value.toString()
						?
						<label htmlFor={input.name} className="form-label m-0 foodList_View_Data">{option.name ? option.name : "-"}</label>
						: null
				))
			) : (
				<input {...input} id={input.name} autoComplete="off" className="form-control" placeholder={label} type={type} {...props} />
			)}
			{touched &&
				((error && <span className="span-error">{error}</span>) ||
					(warning && <span className="span-warning">{warning}</span>))}
			{touched &&
				((error && <span className="text-danger">{error}</span>) ||
					(warning && <span className="text-danger">{warning}</span>))}
			{responseError && <span className="text-danger">{responseError}</span>}
		</div>
	);
};
